import { Box } from '@mui/material';
import { memo } from 'react';

function DangerAlert() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} data-testid="dangeralert">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="none" viewBox="0 0 60 60">
        <rect width="60" height="60" fill="#FEF2F2" rx="30"></rect>
        <path
          stroke="#EF4444"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.67"
          d="M30 27.089V30m0 5.822h.015m-10.1 5.823h20.17c2.24 0 3.641-2.426 2.52-4.367L32.522 19.81c-1.12-1.94-3.922-1.94-5.042 0L17.394 37.278c-1.12 1.94.28 4.367 2.522 4.367z"
        ></path>
      </svg>
    </Box>
  );
}

export default memo(DangerAlert);
